(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goulanar-discovery"] && !Shopify.designMode) return;
  try {
    
  // Release gate: keep false until server-side validation, shipping and voucher delivery are ready.
  const discoveryOrderingEnabled = true;
  const discoverySampleVariants = Object.freeze({
    '12108858261768': 59078688735496,
    '12211638206728': 59078688768264,
    '12211859718408': 59078688801032,
    '12322797945096': 59078688833800,
    '12218846380296': 59078688866568,
    '12312238555400': 59078688899336
  });

  function buildDiscoveryItems(productIds, cart) {
    if (!Array.isArray(productIds) || productIds.length !== 3 || new Set(productIds).size !== 3) {
      throw new Error('invalid');
    }
    const variants = productIds.map((id) => discoverySampleVariants[id]);
    if (variants.some((id) => !Number.isSafeInteger(id))) throw new Error('invalid');
    if (cart) {
      if (cart.currency !== 'EUR' || !Array.isArray(cart.items)) throw new Error('invalid');
      const sampleIds = new Set(Object.values(discoverySampleVariants));
      if (cart.items.some((item) => String(item.product_id) === '12345774145800' || sampleIds.has(Number(item.variant_id)))) {
        throw new Error('duplicate');
      }
    }
    return variants.map((id) => ({ id, quantity: 1, properties: { '_discovery_set': '3x3ml-v1' } }));
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.gdn__radio')) return;
    const section = input.closest('.gdn');
    if (!section) return;
    const inputs = Array.from(section.querySelectorAll('.gdn__radio'));
    let selected = inputs.filter((item) => item.checked);
    if (selected.length > 3) {
      input.checked = false;
      selected = inputs.filter((item) => item.checked);
    }
    inputs.forEach((item) => { item.disabled = selected.length === 3 && !item.checked; });
    const status = section.querySelector('[data-discovery-count]');
    if (status) status.textContent = selected.length + ' von 3 Düften ausgewählt' + (selected.length === 3 ? ' · Dein Set ist vollständig.' : '');
    const button = section.querySelector('[data-discovery-review]');
    if (button) button.disabled = selected.length !== 3;
    const result = section.querySelector('[data-discovery-result]');
    if (result) result.textContent = '';
  });

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-discovery-review]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    const section = button.closest('.gdn');
    if (!section || section.dataset.busy === 'true') return;
    const result = section.querySelector('[data-discovery-result]');
    if (!result) return;
    const inputs = Array.from(section.querySelectorAll('.gdn__radio:checked'));
    const productIds = inputs.map((input) => input.value);
    let requestAttempted = false;
    try {
      buildDiscoveryItems(productIds);
      if (!discoveryOrderingEnabled) {
        result.textContent = inputs.map((input) => input.dataset.fragranceName).join(' · ') + ' — ' + result.dataset.reviewMessage;
        return;
      }
      section.dataset.busy = 'true';
      button.disabled = true;
      section.querySelector('.gdn__fieldset').disabled = true;
      const root = window.Shopify.routes.root;
      const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('request');
      const items = buildDiscoveryItems(productIds, await cartResponse.json());
      requestAttempted = true;
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('request');
      window.location.assign(root + 'cart');
    } catch (error) {
      const key = error.message === 'duplicate' ? 'duplicateMessage' : error.message === 'invalid' ? 'invalidMessage' : 'errorMessage';
      result.textContent = result.dataset[key];
      // An interrupted POST may have succeeded: never automatically retry it.
      if (!requestAttempted) {
        section.dataset.busy = 'false';
        section.querySelector('.gdn__fieldset').disabled = false;
        button.disabled = inputs.length !== 3;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
